import baseRoute from '../baseRoute';

type RouteWithoutQuery = `${typeof baseRoute}/job/${':jobId' | number}`;

type RouteDefinition = RouteWithoutQuery | `${RouteWithoutQuery}?group=${string}`;

export type * from './viewModel';

export const ROUTE: RouteDefinition = `${baseRoute}/job/:jobId`;

export const URL = (jobId: number, group: string): RouteDefinition => `${baseRoute}/job/${jobId}?group=${group}`;
